import React, { useContext } from "react";
import { CardContext } from "../../store/CardContext";

function TabMenu({ activeTab, handleTabClick,Highlightcolor ,color ,Iconcolor ,BtIColor}) {
  
  const [cardData] = useContext(CardContext)
   
  const {
    website,
    review,
    fileName,
  } = cardData
  return (
    <div className="flex">
      <ul className="flex overflow-x-scroll w-100 scrollbar-hide cursor-pointer"     style={{ backgroundColor: `${Iconcolor ? Iconcolor : ""}` }}>
      <li
  className={`mb-0 ${
    activeTab === 1 ? `border-b-2` : ""
  }`}
  style={{
    borderColor: activeTab === 1 && BtIColor ? BtIColor : "black",

  }}
  onClick={() => handleTabClick(1)}
>
  <div className=" w-[65px] h-[49px] flex justify-center items-center">
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.7608 19C4.07859 17.435 4.92766 16.028 6.16414 15.0173C7.40062 14.0067 8.94847 13.4546 10.5454 13.4546C12.1424 13.4546 13.6902 14.0067 14.9267 15.0173C16.1632 16.028 17.0123 17.435 17.3301 19M14.007 7.92308C14.007 9.83483 12.4572 11.3846 10.5454 11.3846C8.63367 11.3846 7.08388 9.83483 7.08388 7.92308C7.08388 6.01132 8.63367 4.46154 10.5454 4.46154C12.4572 4.46154 14.007 6.01132 14.007 7.92308ZM2.93003 1H18.1608C18.9255 1 19.5455 1.61991 19.5455 2.38462V17.6154C19.5455 18.3801 18.9255 19 18.1608 19H2.93003C2.16532 19 1.54541 18.3801 1.54541 17.6154V2.38462C1.54541 1.61991 2.16532 1 2.93003 1Z"
        stroke={BtIColor ? BtIColor : "black"}
        strokeWidth="1.38462"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
</li>

        <li
          className={`mb-0 ${
            activeTab === 2 ? " border-b-2" : ""
          }`}
          onClick={() => handleTabClick(2)}
          style={{
            borderColor: activeTab === 2 && BtIColor ? BtIColor : "black",
   
          }}
        >
          <div className=" w-[65px] h-[49px] flex justify-center items-center h-[50px]">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.63612 16.3635C2.37743 15.1049 1.52023 13.5013 1.17295 11.7555C0.825666 10.0096 1.00389 8.20007 1.68508 6.55556C2.36627 4.91104 3.51983 3.50547 4.99988 2.51659C6.47993 1.5277 8.21999 0.999924 10 1M16.3639 3.63573C17.6226 4.89435 18.4798 6.49796 18.827 8.24377C19.1743 9.98957 18.9961 11.7992 18.3149 13.4437C17.6337 15.0882 16.4802 16.4938 15.0001 17.4826C13.5201 18.4715 11.78 18.9993 10 18.9992M8.09485 8.29153L9.55464 11.2106M8.09485 8.29153L11.5004 4.88599L14.419 10.7242L9.55464 11.2106M8.09485 8.29153L6.14909 9.26441C5.56435 9.55655 5.61373 10.6259 5.90587 11.2106C6.19801 11.7954 7.02413 12.4757 7.60887 12.1835L9.55464 11.2106M9.1245 11.4589L10.3406 13.8911L9.36772 14.3776L8.15162 11.9454M16.4456 3.0676C16.4456 3.87356 15.7922 4.52692 14.9862 4.52692C14.1803 4.52692 13.5269 3.87356 13.5269 3.0676C13.5269 2.26164 14.1803 1.60828 14.9862 1.60828C15.7922 1.60828 16.4456 2.26164 16.4456 3.0676ZM6.47308 16.9316C6.47308 17.7376 5.81972 18.3909 5.01375 18.3909C4.20779 18.3909 3.55443 17.7376 3.55443 16.9316C3.55443 16.1257 4.20779 15.4723 5.01375 15.4723C5.81972 15.4723 6.47308 16.1257 6.47308 16.9316Z"     stroke={BtIColor ? BtIColor : "black"}  stroke-width="1.12495" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

          </div>
        </li>
        <li
          className={`mb-0 ${
            activeTab === 3 ? " border-b-2 " : ""
          }`}
          onClick={() => handleTabClick(3)}
          style={{
            borderColor: activeTab === 3 && BtIColor ? BtIColor : "black",
         
          }}
        >
          {" "}
          <div className=" w-[65px] h-[49px] flex justify-center items-center h-[50px]">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 7.99997C18 8.5304 17.7893 9.03911 17.4142 9.41418C17.0391 9.78926 16.5304 9.99997 16 9.99997C15.4696 9.99997 14.9609 9.78926 14.5858 9.41418C14.2107 9.03911 14 8.5304 14 7.99997C14 7.46954 14.2107 6.96083 14.5858 6.58576C14.9609 6.21068 15.4696 5.99997 16 5.99997C16.5304 5.99997 17.0391 6.21068 17.4142 6.58576C17.7893 6.96083 18 7.46954 18 7.99997Z"
                fill={BtIColor ? BtIColor : "black"}
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.943 1.24997H12.057C14.366 1.24997 16.175 1.24997 17.587 1.43997C19.031 1.63397 20.171 2.03997 21.066 2.93397C21.961 3.82897 22.366 4.96897 22.56 6.41397C22.75 7.82497 22.75 9.63397 22.75 11.943V12.031C22.75 13.94 22.75 15.502 22.646 16.774C22.542 18.054 22.329 19.121 21.851 20.009C21.641 20.4 21.381 20.751 21.066 21.066C20.171 21.961 19.031 22.366 17.586 22.56C16.175 22.75 14.366 22.75 12.057 22.75H11.943C9.634 22.75 7.825 22.75 6.413 22.56C4.969 22.366 3.829 21.96 2.934 21.066C2.141 20.273 1.731 19.286 1.514 18.06C1.299 16.857 1.26 15.36 1.252 13.502C1.25 13.029 1.25 12.529 1.25 12.001V11.943C1.25 9.63397 1.25 7.82497 1.44 6.41297C1.634 4.96897 2.04 3.82897 2.934 2.93397C3.829 2.03897 4.969 1.63397 6.414 1.43997C7.825 1.24997 9.634 1.24997 11.943 1.24997ZM6.613 2.92597C5.335 3.09797 4.564 3.42597 3.995 3.99497C3.425 4.56497 3.098 5.33497 2.926 6.61397C2.752 7.91397 2.75 9.62197 2.75 12V12.844L3.751 11.967C4.1902 11.5828 4.75902 11.3798 5.34223 11.3993C5.92544 11.4188 6.47944 11.6593 6.892 12.072L11.182 16.362C11.5149 16.6948 11.9546 16.8996 12.4235 16.9402C12.8925 16.9808 13.3608 16.8546 13.746 16.584L14.044 16.374C14.5997 15.9835 15.2714 15.7931 15.9493 15.834C16.6273 15.8749 17.2713 16.1446 17.776 16.599L20.606 19.146C20.892 18.548 21.061 17.762 21.151 16.653C21.249 15.448 21.25 13.946 21.25 12C21.25 9.62197 21.248 7.91397 21.074 6.61397C20.902 5.33497 20.574 4.56397 20.005 3.99397C19.435 3.42497 18.665 3.09797 17.386 2.92597C16.086 2.75197 14.378 2.74997 12 2.74997C9.622 2.74997 7.913 2.75197 6.613 2.92597Z"
                fill={BtIColor ? BtIColor : "black"}
              />
            </svg>
          </div>
        </li>
        {website[0]?.websiteName ? (
          <li
            className={`mb-0 ${
              activeTab === 4 ? " border-b-2" : ""
            }`}
            style={{
              borderColor: activeTab === 4 && BtIColor ? BtIColor : "black",
            
            }}
            onClick={() => handleTabClick(4)}
          >
            {" "}
            <div className=" w-[65px] h-[49px] flex justify-center items-center h-[50px]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.41667 9.91683H4.08334C3.27639 9.91683 2.58845 9.63236 2.01951 9.06341C1.45056 8.49447 1.16628 7.80672 1.16667 7.00016C1.16667 6.19322 1.45114 5.50527 2.02009 4.93633C2.58903 4.36739 3.27678 4.08311 4.08334 4.0835H6.41667V5.25016H4.08334C3.59723 5.25016 3.18403 5.4203 2.84376 5.76058C2.50348 6.10086 2.33334 6.51405 2.33334 7.00016C2.33334 7.48627 2.50348 7.89947 2.84376 8.23975C3.18403 8.58002 3.59723 8.75016 4.08334 8.75016H6.41667V9.91683ZM4.66667 7.5835V6.41683H9.33334V7.5835H4.66667ZM7.58334 9.91683V8.75016H9.91667C10.4028 8.75016 10.816 8.58002 11.1563 8.23975C11.4965 7.89947 11.6667 7.48627 11.6667 7.00016C11.6667 6.51405 11.4965 6.10086 11.1563 5.76058C10.816 5.4203 10.4028 5.25016 9.91667 5.25016H7.58334V4.0835H9.91667C10.7236 4.0835 11.4116 4.36797 11.9805 4.93691C12.5494 5.50586 12.8337 6.19361 12.8333 7.00016C12.8333 7.80711 12.5489 8.49505 11.9799 9.064C11.411 9.63294 10.7232 9.91722 9.91667 9.91683H7.58334Z"
                  fill={BtIColor ? BtIColor : "black"}
                />
              </svg>
            </div>
          </li>
        ) : (
          ""
        )}
        {review[0]?.reviewName ? (
          <li
            className={`mb-0 ${
              activeTab === 5 ? "  border-b-2 border-black" : ""
            }`}
            onClick={() => handleTabClick(5)}
            style={{
              borderColor: activeTab === 5 && BtIColor ? BtIColor : "black",

            }}
          >
            {" "}
            <div className=" w-[65px] h-[49px] flex justify-center items-center h-[50px]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 27 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.549 9.217L15 0L10.451 9.217L0.280029 10.695L7.64003 17.87L5.90203 28L13 24.269V22.009L8.55903 24.344L9.61103 18.208L9.78903 17.171L9.03603 16.438L4.57803 12.091L10.739 11.196L11.779 11.045L12.245 10.102L15 4.519L17.755 10.102L18.221 11.045L19.261 11.196L26.715 12.281L27 10.3L19.549 9.217Z"
                  fill={BtIColor ? BtIColor : "black"}
                />
              </svg>
            </div>
          </li>
        ) : (
          ""
        )}
        {fileName?.fileName1 ||
        fileName?.fileName2 ||
        fileName?.fileName3 ||
        fileName?.fileName4 ? (
          <li
            className={`mb-0 ${
              activeTab === 6 ? "  border-b-2 border-black" : ""
            }`}
            onClick={() => handleTabClick(6)}
            style={{
              borderColor: activeTab === 6 && BtIColor ? BtIColor : "black",
          
            }}
          >
            {" "}
            <div className=" w-[65px] h-[49px] flex justify-center items-center h-[50px]">
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 1V7H15M3 19C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V1H10L15 6V17C15 17.5304 14.7893 18.0391 14.4142 18.4142C14.0391 18.7893 13.5304 19 13 19H3Z"      stroke={BtIColor ? BtIColor : "black"} stroke-width="1.5" stroke-linejoin="round"/>
</svg>

            </div>
          </li>
        ) : (
          ""
        )}
      </ul>
    </div>
  );
}

export default TabMenu;
